var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.426181,
    d: "M6.67015 21.625C8.02367 21.625 9.37718 21.1328 10.4026 20.1074L19.344 11.166C19.508 10.9609 19.508 10.6738 19.344 10.4688L19.0979 10.2227C18.8928 10.0586 18.6057 10.0586 18.4006 10.2227L9.45921 19.1641C7.90062 20.7227 5.39867 20.7227 3.84007 19.1641C2.28148 17.6055 2.28148 15.1035 3.84007 13.5449L14.5862 2.79883C15.6936 1.69141 17.4983 1.69141 18.5647 2.79883C19.6721 3.86523 19.6721 5.66992 18.5647 6.77734L9.45921 15.9238C8.80296 16.5391 7.73656 16.5391 7.08031 15.9238C6.46507 15.2676 6.46507 14.2012 7.08031 13.5449L14.094 6.57227C14.258 6.36719 14.258 6.08008 14.094 5.875L13.8479 5.62891C13.6428 5.46484 13.3557 5.46484 13.1506 5.62891L6.17796 12.6426C4.98851 13.791 4.98851 15.6777 6.17796 16.8262C7.3264 18.0156 9.21312 18.0156 10.3616 16.8262L19.508 7.7207C21.1077 6.08008 21.1077 3.45508 19.508 1.85547C17.9084 0.255859 15.2834 0.255859 13.6428 1.85547L2.89671 12.6016C0.845933 14.6523 0.845933 18.0156 2.89671 20.1074C3.9221 21.1328 5.31664 21.625 6.67015 21.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLight);
export default __webpack_public_path__ + "static/media/PinLight.1f19307d8e63e5903e3a5af2dbff7b98.svg";
export { ForwardRef as ReactComponent };